// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__3N1xd","detailsBorder":"styles_detailsBorder__3r2ZL"};